import { devSimulatePing } from '~/rage/decorators';
import { IObservable, SeenTracker, Subject } from '~/rage/utils';
import { Gender, WalletType } from '~/shared';
import {
	ClothesShopCategoryIndex,
	IClothesShopItem,
	IClothesShopService,
} from './clothesShopServiceTypes';

export class ClothesShopServiceStub implements IClothesShopService {
	private seenTracker = new SeenTracker(null);
	private gender = new Subject<Gender>(Gender.MALE);

	private readonly wearingItems = new Subject<string[]>(['jacket-2']);

	private readonly shopItems = new Subject<IClothesShopItem[]>([
		{
			id: 'ccl_m_1508',
			name: 'Пальто (черное)',
			price: 1500,
			oldPrice: 2000,
			discount: 25,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1509',
			name: 'Пальто (черное)',
			price: 1500,
			oldPrice: 2000,
			discount: 25,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1510',
			name: 'Пальто (черное)',
			price: 1500,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1511',
			name: 'Пальто (черное)',
			price: 1500,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1512',
			name: 'Пальто (черное)',
			price: 1500,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1513',
			name: 'Пальто (черное)',
			price: 1500,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1514',
			name: 'Пальто (красное)',
			price: 1500,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: 'ccl_m_1508',
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1515',
			name: 'Пальто (синее)',
			price: 1500,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: 'ccl_m_1508',
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1516',
			name: 'Куртка (черная)',
			price: 1000,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: null,
			wallet: WalletType.Donate,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1607',
			name: 'Куртка (серая)',
			price: 1000,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: 'ccl_m_1516',
			wallet: WalletType.Donate,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1517',
			name: 'Рубашка (белая)',
			price: 500,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1518',
			name: 'Рубашка (синяя)',
			price: 500,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: 'ccl_m_1517',
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1519',
			name: 'Футболка',
			price: 300,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: null,
			wallet: WalletType.Donate,
			gender: Gender.MALE,
		},
		...new Array(40).fill(0).map((_, index) => ({
			id: `ccl_m_15${index + 20}`,
			name: `Футболка ${index + 10}`,
			price: 300,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: null,
			wallet: WalletType.Donate,
			gender: Gender.MALE,
		})),
		{
			id: 'ccl_m_1520',
			name: 'Брюки (черные)',
			price: 800,
			category: ClothesShopCategoryIndex.PANTS,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1521',
			name: 'Брюки (синие)',
			price: 800,
			category: ClothesShopCategoryIndex.PANTS,
			parentItemId: 'ccl_m_1520',
			wallet: WalletType.Donate,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1522',
			name: 'Ботинки (черные)',
			price: 1200,
			category: ClothesShopCategoryIndex.PANTS,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1523',
			name: 'Маска (черная)',
			price: 300,
			category: ClothesShopCategoryIndex.MASK,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.COMMON,
		},
		{
			id: 'ccl_m_1524',
			name: 'Шляпа (черная)',
			price: 400,
			category: ClothesShopCategoryIndex.HAT,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.COMMON,
		},
		{
			id: 'ccl_m_1525',
			name: 'Очки (черные)',
			price: 200,
			category: ClothesShopCategoryIndex.GLASSES,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.COMMON,
		},
		{
			id: 'ccl_m_1526',
			name: 'Рюкзак (черный)',
			price: 1000,
			category: ClothesShopCategoryIndex.BACKPACK,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
		{
			id: 'ccl_m_1527',
			name: 'Аксессуары (черные)',
			price: 600,
			category: ClothesShopCategoryIndex.ACCESSORIES,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
	] as IClothesShopItem[]);

	private readonly ownedItems = new Subject<IClothesShopItem[]>([
		{
			id: 'jacket-1',
			name: 'Пальто (черное)',
			price: 1500,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
		{
			id: 'jacket-2',
			name: 'Пальто (красное)',
			price: 1500,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: 'jacket-1',
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},

		{
			id: 'f-jacket-1',
			name: 'Пальто',
			price: 15000,
			category: ClothesShopCategoryIndex.TOP,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.FEMALE,
		},
		{
			id: 'pants-1',
			name: 'Брюки (черные)',
			price: 800,
			category: ClothesShopCategoryIndex.PANTS,
			parentItemId: null,
			wallet: WalletType.Cash,
			gender: Gender.MALE,
		},
	] as IClothesShopItem[]);

	getPlayerGender(): IObservable<Gender> {
		return this.gender;
	}

	getShopItems(): IObservable<IClothesShopItem[]> {
		return this.shopItems;
	}

	getShopItemById(itemId: string): IClothesShopItem | null {
		return this.shopItems.getValue().find((item) => item.id === itemId) || null;
	}

	getWearingItems(): IObservable<string[]> {
		return this.wearingItems;
	}

	async previewItem(itemId: string): Promise<void> {
		console.log('previewItem', { itemId });
	}

	async clearPreview(): Promise<void> {
		console.log('clearPreview');
	}

	async exitShop(): Promise<void> {
		console.log('exitShop');
	}

	@devSimulatePing()
	public async buy(itemId: string, wallet: WalletType): Promise<void> {
		const items = this.shopItems.getValue();
		const newOwnedItem = items.find((item) => item.id === itemId);
		if (!newOwnedItem) {
			return;
		}

		console.log('clothesShop:buy', { itemId, wallet });

		this.ownedItems.next([...this.ownedItems.getValue(), newOwnedItem]);
	}

	isUnseen(path: string): boolean {
		return this.seenTracker.isUnseen(path);
	}

	markSeen(path: string): void {
		console.log('clothesShop:markSeen', path);
		this.seenTracker.markAsSeen(path);
	}
}
